import { ButtonVariant, CoButton } from "components/CoButton";
import { useConsensusMeterFilter } from "../hooks/useConsensusMeterFilter";
import { defaultMeterFilter } from "../utils";

interface MeterFilterProps {
  onFilterToggle: () => void;
  isFilteringEnabled: boolean;
  disabled: boolean;
  threadInteractionId?: string;
}

/**
 * Component that provides filtering functionality for the consensus meter
 */
export const MeterFilter = ({
  onFilterToggle,
  isFilteringEnabled,
  disabled,
  threadInteractionId,
}: MeterFilterProps) => {
  const { setMeterFilter } = useConsensusMeterFilter(threadInteractionId);

  const handleFilteringToggle = () => {
    onFilterToggle();
    if (isFilteringEnabled) {
      setMeterFilter(defaultMeterFilter);
    }
  };

  return (
    <CoButton
      aria-label="Enable Category Filter"
      size="sm"
      variant={ButtonVariant.Flat}
      icon="icon-list-filter"
      disabled={disabled}
      onClick={handleFilteringToggle}
      className="text-fg-base mr-[-10px]"
    />
  );
};
